module.exports = __webpack_public_path__ + "static/media/digital-ocean.52717ce3.svg";